import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Bot } from "lucide-react";
import { api, shortDate } from "../../lib/api";
import { useAuth, apiError } from "../../lib/auth";
import { NeonButton } from "../common";
import { Switch } from "../ui/switch";

export const AutopilotPanel = () => {
  const { isOwner } = useAuth();
  const [d, setD] = useState(null);
  const [f, setF] = useState(null);
  const load = useCallback(() => api.get("/autopilot").then((r) => { setD(r.data); setF(r.data.settings); }), []);
  useEffect(() => { load(); }, [load]);
  const save = async () => { try { setF((await api.put("/autopilot", f)).data); toast.success("Autopilot saved"); } catch (e) { toast.error(apiError(e)); } };
  if (!d || !f) return null;
  const inp = "w-20 bg-field border border-fieldline px-2 py-1 font-mono text-sm focus:outline-none focus:border-brand";
  return (
    <section className="panel p-5" data-testid="autopilot-panel">
      <div className="flex items-center justify-between">
        <p className="label-xs flex items-center gap-2"><Bot className="w-3.5 h-3.5 text-brand" /> Dispute autopilot</p>
        <Switch disabled={!isOwner} checked={f.enabled} onCheckedChange={(v) => setF({ ...f, enabled: v })} data-testid="autopilot-toggle" />
      </div>
      <p className="text-xs text-white/55 mt-2">When a Whop dispute arrives, AEGIS gathers evidence, scores it and acts on its own. At or above <b>{f.submit_at}%</b> it drafts and submits automatically. From <b>{f.defend_at}%</b> it drafts and stages for your one-click approval. Below that it refunds warnings early, and leaves lost-cause chargebacks uncontested (never refunding twice). Dry-run mode in Settings blocks real submissions.</p>
      <div className="flex flex-wrap items-center gap-4 mt-3 text-sm">
        <label className="flex items-center gap-2">Auto-submit at <input type="number" disabled={!isOwner} value={f.submit_at} onChange={(e) => setF({ ...f, submit_at: Number(e.target.value) })} className={inp} data-testid="autopilot-submit-at" />%</label>
        <label className="flex items-center gap-2">Defend from <input type="number" disabled={!isOwner} value={f.defend_at} onChange={(e) => setF({ ...f, defend_at: Number(e.target.value) })} className={inp} data-testid="autopilot-defend-at" />%</label>
        {isOwner && <NeonButton onClick={save} data-testid="autopilot-save">Save</NeonButton>}
      </div>
      <ul className="mt-4 divide-y divide-divider text-sm max-h-64 overflow-y-auto" data-testid="autopilot-log">
        {d.actions.map((a) => (
          <li key={a.id} className="py-2 flex gap-3" data-testid={`autopilot-action-${a.id}`}><span className={`font-mono text-[10px] w-16 ${a.decision === "DEFEND" ? "text-brand" : "text-amber-300"}`}>{a.decision}</span><span className="flex-1 text-white/70">{a.detail}</span><span className="font-mono text-[10px] text-white/40">{a.confidence}% · {shortDate(a.at)}</span></li>
        ))}
        {!d.actions.length && <li className="py-2 text-white/45">No autopilot decisions yet.</li>}
      </ul>
    </section>
  );
};
